/**
 * Application entry point
 */

// Load application styles
import "styles/index.scss";
import p5 from "p5"

import chroma from 'chroma-js'

import dat from "dat.gui";
import Stats from "stats-js";

import rect from 'images/rect.svg'
import x from 'images/x.svg'
import a from 'images/a.svg'
import square from 'images/square.svg'
import invader from 'images/invader.svg'
import radioactive from 'images/radioactive.svg'
import o from 'images/o.svg'

import { PALLET_SIZE, RND_SEED, SHAPES, DRAW_PER_TICK, DRAW_MODE, CANVAS_SIZE } from './constants'
import { convert2DTo1D, convert1DTo2D, getPixel, gridCoordsToWorldCoords, worldCoordsToGridCoords, drawPolygon } from './helpers'
import { rotate } from "./polygon";
import SCALES from './scales'

import { pallets, colorRamps } from './pallets'
import layouts from './layouts'

const polygonSet = new Set()

// pallet should have nice color split - then use 2 pallets for each pass over the shape

// make the colours from the pallet

let layout = layouts[lyt]
let pallet = pallets[pz[palletNum]]

let palletsFG = [
  ...pallet.fg.map(p => chroma.scale(colorRamps[p]).mode('lch').colors(PALLET_SIZE))
]
let palletsBG = [
  ...pallet.bg.map(p => chroma.scale(colorRamps[p]).mode('lch').colors(PALLET_SIZE))
]

let draw_mode = DRAW_MODE[mode]
let scaling_factor = SCALES[scalingz]

let bgColor = chroma.scale([white_background ? '#FFF' : '#000', !invert_pallet ? palletsBG[0][0] : palletsFG[0][0]]).mode('lch').colors(PALLET_SIZE)[Math.floor(PALLET_SIZE / 7)]

// get bgcolor as rgb
let bgColorRGB

const target = 727

let finished = false

let fgPasses = []
let bgPasses = []

let fgPixelArr = []
let bgPixelArr = []

let drawLayer = null
let canvas = null

// -----------------------------
let scaleCenter = [10, 10]
const res = 10
const sketch = p5 => {
  // Variables scoped within p5
  const canvasWidth = CANVAS_SIZE //p5.windowWidth;
  const canvasHeight = CANVAS_SIZE //p5.windowHeight;

  drawLayer = p5.createGraphics(CANVAS_SIZE, CANVAS_SIZE)

  let bgShape = null

  p5.preload = () => {
    bgShape = p5.loadImage(require(`images/${is_skull ? 'skulls/' : ''}${shape}.svg`)) 
  };

  p5.windowResized = () => {
    p5.resizeCanvas(p5.windowWidth, p5.windowHeight)
  }
  
  // Setup function
  // ======================================
  p5.setup = () => {
    // get seed from url
    const urlParams = new URLSearchParams(window.location.search);
    const seed = fxrand() * 10000
    const bgRotate = 0 // getRnd(360)


    p5.noiseSeed(seed)
    p5.randomSeed(seed)

    canvas = p5.createCanvas(canvasWidth, canvasHeight);
    drawLayer.background(bgColor)
    drawLayer.loadPixels()
    bgColorRGB = getPixel(drawLayer, 0,0)
    drawLayer.noSmooth()
    drawLayer.noStroke()
    drawLayer.angleMode(p5.DEGREES);

    if (draw_mode == DRAW_MODE.SHAPE) {
      const { coords, canvas: canvas1 } = placeShapeAndGetGridPointsArray(bgShape, 0, 0, 800, 800, bgRotate)

      fgPixelArr = [ ...coords ]
      // invert the grid by creating an array of the same size and removing the coords that are in the shape
      // start at 100 because that's the first index of the grid if you start on y=1
      for (let i=100; i< Math.floor(drawLayer.width / res) * Math.floor(drawLayer.width / res); i++) {
        if (!coords.includes(i)) {
          bgPixelArr.push(i)
        }
      }
    } else {
      for (let i=100; i< Math.floor(drawLayer.width / res) * Math.floor(drawLayer.width / res); i++) {
        fgPixelArr.push(i)
        bgPixelArr.push(i)
      }
    }

    // draw mode can use a shape or not
    // if it does use a shape, it may want a background

    // If draw mode is using a skull, it might not want to draw the background

    // drawpass for each shape in the pallet
  
    layout.fg.forEach((shape) => {
      fgPasses.push([shape, shape.attempts])
      //const plt = invert_pallet ? palletsBG : palletsFG
      //drawShapeLayer(coords, shape, plt, FG_MOVE_REZ, PALLET_REZ)
    })

    //
    if (show_background) {
      layout.bg.forEach((shape) => {
        bgPasses.push([shape, shape.attempts])
      })
    }
    // set total passes for fg and bg

    p5.resizeCanvas(p5.windowWidth, p5.windowHeight)
  };

  function drawShapeLayer (coords, shape, pallet, attempts, placement_rez, color_rez, rotate_rez, size_rez) {
    const { shape: shapeType, rotate, scale, pallet: palletIndex } = shape
    drawPass(coords, scale, pallet[palletIndex], placement_rez, color_rez, rotate_rez, size_rez, attempts, shapeType, rotate)
  }

  function doDrawing (coords, pallets, passes, move_rez, pallet_rez, rotation_rez, size_rez) {
    for (let i=0; i< passes.length; i++) {
      const [shape, attempts] = passes[i]
      //console.log(shape, attempts, DRAW_PER_TICK)
      let attemptCount = DRAW_PER_TICK < attempts ? DRAW_PER_TICK : attempts
      drawShapeLayer(coords, shape, pallets, attemptCount, move_rez, pallet_rez, rotation_rez, size_rez)
      passes[i][1] -= DRAW_PER_TICK
      if (passes[i][1] <= 0) passes.splice(i, 1)
    }
  }

  // Draw function
  // ======================================
  p5.draw = () => {
    if (finished) {
      p5.noLoop()
      try {
        if (fxpreview) fxpreview()
      } catch (err) {}
    }
    // do fgPasses and bgPasses until they are all done
    doDrawing(fgPixelArr, invert_pallet ? palletsFG : palletsBG, fgPasses, scaling_factor.FG_MOVE_REZ, scaling_factor.FG_PALLET, scaling_factor.FG_ROTATE, scaling_factor.FG_SCALE)
    doDrawing(bgPixelArr, invert_pallet ? palletsBG : palletsFG, bgPasses, scaling_factor.BG_MOVE_REZ, scaling_factor.BG_PALLET, scaling_factor.BG_ROTATE, scaling_factor.BG_SCALE)
    if (fgPasses.length == 0 && bgPasses == 0) finished = true
    updateCanvas(p5)
  };

  // Helper functions

  // draw the points in a grid
  function drawGrid (gridData, color) {
    // draw the grid
    p5.stroke(color)
    p5.noFill()
    // need to know the size of the grid at the time the shape was created
    const gridSize = Math.floor(p5.width / res)
    gridData.forEach((p) => {
      const [i, j] = gridCoordsToWorldCoords(convert1DTo2D(p, gridSize), res)
      if (p == target) {
        p5.stroke('white')
      } else {
        p5.stroke(color)
      }
      p5.point(i, j)
    })

    

    updateCanvas(p5)
  }

  function updateCanvas (p5) {
    const size = p5.windowWidth >  p5.windowHeight ?  p5.windowHeight:  p5.windowWidth
    const offset = size == CANVAS_SIZE ? { x: 0, y: 0 } : 
      p5.windowWidth <  p5.windowHeight ? { x: 0, y: (( p5.windowHeight - size) / 2) } :
        { x: ((p5.windowWidth - size) / 2), y: 0 }

    p5.image(drawLayer, offset.x, offset.y, size, size)
  }

  function getRnd (max, min = 0) {
    // Compute the range of possible values, adding 1 to include the maximum value
    const range = max - min + 1;
  
    // Generate a random whole number within the range
    const randomNumber = Math.floor(p5.random() * range) + min;
  
    // Return the random number
    return randomNumber;
  }

  function drawPass (placementArray, zoom, pallet, placement_rez, color_rez, rotate_rez, size_rez, attempts = 100, shape = SHAPES.LINE, ng = 0) {
    //const placementArray = [ ...array ]
    /*for (let a of placementArray) {
      const [x, y] = gridCoordsToWorldCoords(convert1DTo2D(a))
      //rect (x, y, 1, 1)
    }*/
    
    while (attempts > 0) {

      // 2. pick an index from the bucket
      const rndIndex = getRnd(placementArray.length - 1)
      const index = placementArray[rndIndex]
      if (index != undefined) {
        // 3. remove the index from the available options
        placementArray.splice(rndIndex, 1)
        const [x, y] = convert1DTo2D(index, Math.floor(drawLayer.width / res))
        const angle = (ng == 0) ? 360 * p5.noise(x * rotate_rez, y * rotate_rez) : ng
        const [wx, wy] = gridCoordsToWorldCoords([x, y], res)
        // 4. generate the shape and try to place it
        const sx = Math.atan2(scaleCenter[1] - wy, scaleCenter[0] - wx) - Math.PI / 2
        const colorNum = Math.floor(p5.noise(x,y) * (pallet.length - 1))
        const pColor = pallet[colorNum]
        //console.log( getPixel(p5, wx, wy), bgColor)
        
        const cColor = allow_overlap ? getPixel(drawLayer, wx, wy) : bgColorRGB
        
        drawPolygon(drawLayer, shape, [wx,wy], zoom * p5.noise(x * size_rez, y * size_rez), angle, pColor, cColor)
 
        // 5. if placed, append the details to the polygonSet
        polygonSet.add(index, {
          x, y
        })
      }
      
      // decrease attempts if there are still options or set to 0 if not
      if (placementArray.length > 0) attempts -= 1
      else attempts = 0
    }
  }

  // takes a p5 image object and returns an array of the indexes in the grid of colliding pixels
  // based on the resolution of the grid
  function placeShapeAndGetGridPointsArray (name, x, y, width, height, angle, resolution = res) {
    // create an image object
    //const img = p5.createImage(width, height)

    const tmpCanvas = p5.createGraphics(drawLayer.width, drawLayer.height)

    tmpCanvas.translate(drawLayer.width/2, drawLayer.height/2)
    tmpCanvas.rotate(angle)
    tmpCanvas.image(name, x - (width/2), y - (height/2), width, height)
    tmpCanvas.rectMode(p5.CENTER)
    
    const tx = (drawLayer.width / 2) + (x - width / 2)
    const ty = (drawLayer.height / 2) + (y - height / 2)

    const cx = x + (drawLayer.width / 2)
    const cy = y + (drawLayer.height / 2)

    const { x: x1, y: y1 } = rotate(cx, cy, tx, ty, angle)
    const { x: x2, y: y2 } = rotate(cx, cy, tx + width, ty, angle)
    const { x: x3, y: y3 } = rotate(cx, cy, tx + width, ty + height, angle)
    const { x: x4, y: y4 } = rotate(cx, cy, tx, ty + height, angle)

    // get the min, max x and y coords
    const minX = Math.min(x1, x2, x3, x4)
    const maxX = Math.max(x1, x2, x3, x4)
    const minY = Math.min(y1, y2, y3, y4)
    const maxY = Math.max(y1, y2, y3, y4)

    tmpCanvas.loadPixels()

    // create a grid of colliding pixels based on the resolution
    const grid = []
    let grid_size = Math.floor(drawLayer.width / resolution)
    for (let i = minX; i < maxX; i += resolution) {
      for (let j = minY; j < maxY; j += resolution) {
        // check if the pixel is inside the shape
        if (getPixel(tmpCanvas, i, j) !== '0-0-0') {
          if (i > 0 && j > 0 && i < drawLayer.width && j < drawLayer.height) {
            const [x, y] = worldCoordsToGridCoords([i,j], resolution)
            const idx = convert2DTo1D(x, y, grid_size)
            grid.push(idx)
          }
        }
      }
    }

    return { coords: grid, canvas: tmpCanvas }
  }
};

new p5(sketch);

export default sketch;
